"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPassword = exports.postOrganizationsUsers = exports.postAvatar = exports.patchOrganizationsUsers = exports.getOrganizationsUsers = exports.batchAddOrganizationsUsers = void 0;

const utils_1 = require("../utils");

const batchAddOrganizationsUsers = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/users:batch`;
  const params = utils_1.omitIfNil({
    switchingUserType: options.switchingUserType
  });
  return jilFetch(path, params, {
    body: JSON.stringify(options.usersArray),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
};

exports.batchAddOrganizationsUsers = batchAddOrganizationsUsers;

const getOrganizationsUsers = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/users${options.userId ? `/${options.userId}` : ''}`;
  const params = utils_1.omitIfNil({
    fetchProductLicenseGroups: options.fetchProductLicenseGroups,
    filter_exclude_domain: options.filterExcludeDomain,
    filter_include_domain: options.filterIncludeDomain,
    page: options.page,
    page_size: options.pageSize,
    search_query: options.searchQuery,
    sort: options.sort,
    sort_order: options.sortOrder
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getOrganizationsUsers = getOrganizationsUsers;

const patchOrganizationsUsers = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/users`;
  return jilFetch(path, {}, {
    body: JSON.stringify(options.operations),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'PATCH'
  });
};

exports.patchOrganizationsUsers = patchOrganizationsUsers;

const postAvatar = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/users/${options.userId}/avatar`;
  return jilFetch(path, {}, {
    body: options.formData,
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
};

exports.postAvatar = postAvatar;

const postOrganizationsUsers = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/users`;
  return jilFetch(path, {}, {
    body: JSON.stringify(options.organizationUser),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
};

exports.postOrganizationsUsers = postOrganizationsUsers;

const resetPassword = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/users/${options.userId}/reset-password`;
  return jilFetch(path, {}, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
};

exports.resetPassword = resetPassword;